import { SyntheticEvent, useState } from 'react'
import { useNavigate } from 'react-router'
import { Button, FormControlLabel, Grid, Radio, RadioGroup, Typography } from '@mui/material'

import { useHspPlusContext } from '../../../providers/hsp-plus-provider'
import { formatPhoneNumber } from '../../../utils/helpers'
import useIsMobile from '../../../utils/hooks/useIsMobile'
import useSharedStyles from '../shared.styles'

import useStyles from './index.styles'

type PhoneChoice = 'saved' | 'entered' | ''

// TODO: Add route guard once this is integrated with the API/routing

// TODO: replace with the saved and entered numbers once the API is integrated
const savedPhoneNumber = '+12345678900'
const enteredPhoneNumber = '+13345678900'

const HSPPhoneMismatch = () => {
  const isMobile = useIsMobile()
  const navigate = useNavigate()
  const classes = useStyles
  const sharedClasses = useSharedStyles
  const { setValues } = useHspPlusContext()
  const [selectedPhone, setSelectedPhone] = useState<PhoneChoice>('')

  const handleSubmit = (event: SyntheticEvent<HTMLFormElement>) => {
    event.preventDefault()
    if (!selectedPhone) return

    setValues({ mobileNumber: selectedPhone === 'saved' ? savedPhoneNumber : enteredPhoneNumber })
    navigate('/hsp-plus/registration-complete')
  }

  return (
    <Grid container={true} component="form" onSubmit={handleSubmit} sx={classes.screen(isMobile)}>
      <Grid container={true} sx={classes.form}>
        <Grid container={true} sx={classes.intro(isMobile)}>
          <Typography component="h1" variant="h5" sx={sharedClasses.title}>
            Change number?
          </Typography>
          <Typography variant="body2">We found a phone number on file for you. Choose which one works best.</Typography>
        </Grid>

        <RadioGroup
          aria-label="Choose a phone number"
          name="phone-number"
          value={selectedPhone}
          onChange={(event) => setSelectedPhone(event.target.value as PhoneChoice)}
          sx={classes.phoneOptions}
        >
          <FormControlLabel
            value="saved"
            control={<Radio color="secondary" />}
            label={
              <Grid container={true} sx={classes.optionContent}>
                <Typography variant="caption" sx={classes.optionLabel}>
                  Use your saved number
                </Typography>
                <Typography variant="caption" sx={classes.phoneType}>
                  Mobile
                </Typography>
                <Typography variant="h6" sx={classes.phoneNumber}>
                  {formatPhoneNumber(savedPhoneNumber)}
                </Typography>
              </Grid>
            }
            sx={classes.phoneOption}
          />

          <FormControlLabel
            value="entered"
            control={<Radio color="secondary" />}
            label={
              <Grid container={true} sx={classes.optionContent}>
                <Typography variant="caption" sx={classes.optionLabel}>
                  Use the number you just entered
                </Typography>
                <Typography variant="caption" sx={classes.phoneType}>
                  Mobile
                </Typography>
                <Typography variant="h6" sx={classes.phoneNumber}>
                  {formatPhoneNumber(enteredPhoneNumber)}
                </Typography>
              </Grid>
            }
            sx={classes.phoneOption}
          />
        </RadioGroup>

        <Grid container={true} sx={classes.submitContainer}>
          <Button type="submit" variant="contained" size="large" disableElevation disabled={!selectedPhone} sx={classes.continueButton}>
            Continue
          </Button>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default HSPPhoneMismatch
